import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { PublicHeader } from "@/components/PublicHeader";
import { FooterCEG } from "@/components/FooterCEG";

const API = process.env.REACT_APP_BACKEND_URL;

/** Pagina 404 pubblica: nessun redirect automatico verso aree riservate. */
export default function NonTrovata() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (/^\/sitemap(\.xml)?\/?$/i.test(pathname)) window.location.replace(`${API}/api/public/sitemap.xml`);
    if (/^\/robots\.txt$/i.test(pathname)) window.location.replace("/robots.txt");
  }, [pathname]);
  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="pagina-404">
      <PublicHeader />
      <main className="flex-1 px-6 sm:px-12 py-20 max-w-3xl">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#0070BA]">Errore 404</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-slate-900 mt-3">Pagina non trovata</h1>
        <p className="text-slate-600 mt-4">L'indirizzo <code className="bg-slate-100 px-1.5 py-0.5 rounded text-sm">{pathname}</code> non esiste. Forse cercavi una di queste pagine:</p>
        <ul className="mt-6 grid sm:grid-cols-2 gap-2 text-sm">
          {[["/", "Home"], ["/stabilimenti-balneari", "Stabilimenti balneari"], ["/finanza-agevolata", "Incentivi per le imprese"], ["/catalogo-incentivi", "Catalogo bandi"], ["/servizi-esterni", "Studi e professionisti"], ["/login", "Accedi"]].map(([h, l]) => <li key={h}><Link to={h} className="block rounded-xl border border-slate-200 px-4 py-3 hover:border-[#0070BA] hover:text-[#003087]" data-testid={`404-link-${h.replace(/\//g, "") || "home"}`}>{l}</Link></li>)}
        </ul>
        <p className="mt-6 text-xs text-slate-500">Sitemap per i motori di ricerca: <a href={`${API}/api/public/sitemap.xml`} className="underline">sitemap.xml</a></p>
      </main>
      <FooterCEG compact />
    </div>
  );
}
